"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSessionId = useSessionId;
var _useShoppingContext = require("./useShoppingContext");
function useSessionId() {
  const {
    shoppingContext: {
      sessionId: rawSessionId
    } = {}
  } = (0, _useShoppingContext.useShoppingContext)();
  return rawSessionId ?? '';
}
//# sourceMappingURL=useSessionId.js.map